import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../../global/util/Constant';

@Injectable({
  providedIn: 'root'
})
export class AdsService {
  adsUrl = Constant.ROOT_API_V1.concat('/notices/');

  constructor(private http: HttpClient) {
  }

  getAll(noticeUrl: string): Observable<any> {
    return this.http.get<any>(noticeUrl);
  }

  save(formData: FormData): Observable<any> {
    return this.http.post(this.adsUrl.concat('add'), formData,
      {
        reportProgress: true,
        observe: 'events'
      });
  }

  update(formData: FormData): Observable<any> {
    return this.http.put(this.adsUrl.concat('edit'), formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  getAllNewAds(): Observable<any> {
    return this.http.get(Constant.ROOT_API_V1.concat('/public/new/notices/'));
  }

  delete(id: number): Observable<any> {
    return this.http.delete(this.adsUrl.concat('?adId=').concat(String(id)));
  }

  getLastAds(): Observable<any> {
    return this.http.get(Constant.ROOT_API_V1.concat('/public/last/notices/'));
  }
}
